import Icon from '../../fragments/icon/Icon';
import RichText from '../../fragments/rich-text/RichText';

export default function TimelinePanel({ item, index, icon }) {
  // console.log(item);
  if (!item) return null;

  return (
    <div className={'BlockTimeline-item'}>
      <div className={'BlockTimeline-icon'}>
        {icon ? (
          <Icon icon={icon} size="large" />
        ) : (
          <Icon
            character={index < 9 ? `0${index + 1}` : `${index + 1}`}
            size="large"
          />
        )}
      </div>

      <div className={'BlockTimeline-itemContent'}>
        {item.heading && (
          <h3
            className={'h6'}
            dangerouslySetInnerHTML={{ __html: item.heading }}
          ></h3>
        )}
        <RichText html={item.contentHtml} />
      </div>
    </div>
  );
}
